import { Directive, ElementRef, EventEmitter, HostListener, Output, Input } from '@angular/core';

@Directive({
  selector: '[numberMask]'
})
export class NumberMaskDirective {

  @Input() numberMask: boolean = true;
  @Output() numberChange = new EventEmitter<number>();

  constructor(private el: ElementRef) { }

  value: string;

  @HostListener('input', ['$event']) onInputChange(event) {
    if (this.numberMask === false) return;

    const regex = /^[0-9]+$/g;
    const initalValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initalValue.replace(/[^0-9-]*/g, '');
    if (regex.test(initalValue) || initalValue === '') {
      this.numberChange.emit(event);
    }
  }
}